<template>
  <div>
    <v-container fluid>
      <v-toolbar dark class="header-title">
        <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t('dashboardScore') }}</v-toolbar-title>
        
      </v-toolbar>
      <v-card class="card2" style="margin-top: 1rem">
        <v-flex class="flex">
          <v-row style="margin: 1em 0">
            <v-col cols="12" sm="12" md="7">
              <v-btn 
                id="button-reprocess-dashboardscore" 
                :loading="loadingbtn" 
                variant="flat"
                color="purple-darken-1"
                size="large"
                class="reprocess-btn mt-3"
                style="margin-left: 1em; width: 140px; height: 44px"
                @click="OpenDialogReprocess()"
                prepend-icon="mdi-refresh"
              >
                REPROCESS
              </v-btn>
            </v-col>
            <v-col cols="12" sm="12" md="4" class="mt-3">
              <v-autocomplete 
                id="validationprocess-autocomplete-dashboardscore" 
                label="Validation process" 
                :items="DDValidationProcess" 
                item-title="name" 
                item-value="id"
                clearable 
                variant="outlined"
                density="comfortable"
                color="primary"
                v-model="ProcessID"
                hide-details="auto"
                class="modern-field"
                ref="auto"
              >
                <template v-slot:item="{ props, item, index }">
                  <v-list-item 
                    v-bind="props"
                    :id="'validationprocess-option-' + index" 
                    :value="item.raw.name" 
                  >
                    <template v-slot:title>
                      <span>{{ item.raw.name }}</span>
                    </template>
                  </v-list-item>
                </template>
                <template v-slot:prepend-inner>
                  <v-icon color="primary" size="small">mdi-cog-outline</v-icon>
                </template>
                <template v-slot:append-inner>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        v-bind="props"
                        color="grey-darken-1"
                        size="small"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>Select validation process to view dashboard score</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="1" class="mt-4" style="display: flex; align-items: center;">
              <v-btn 
                id="button-search-dashboardscore" 
                icon
                variant="flat"
                color="primary"
                size="large"
                class="search-btn"
                @click="SearchData"
                :disabled="!ProcessID"
              >
                <v-icon size="24">mdi-magnify</v-icon>
                <v-tooltip activator="parent" location="top">
                  {{ $t('search') }}
                </v-tooltip>
              </v-btn>
            </v-col>
            <v-col cols="12" sm="12" md="7">
              <v-card class="card-2">
                <highcharts v-if="isChartOptions" :options="chartOptions"></highcharts>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="5">
              <v-card class="card-1 d-flex align-center mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" fill="currentColor"
                  class="bi bi-bar-chart-line-fill" viewBox="0 0 16 16" style="margin-left: 1em; color: #1976d2">
                  <path
                    d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1V2z" />
                </svg>
                <label style="color: #4c4c4c; padding-left: 1em; font-weight: 700; font-size: 18px">
                  {{ $t('averageScore') }}
                  <br /><span id="averagescore" style="color: #8e8e8e; font-size: 40px">{{ averageScore }} {{ $t('score') }}</span>
                </label>
              </v-card>
              <v-card class="card-1 d-flex align-center mb-6">
                <div style="border-radius: 5px; padding-left: 1em; font-weight: 700; font-size: 14px">
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">Model Name : {{ModelName}}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">Versioning : {{ Version }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">Processing Date :  {{ processDate }}</label>
                </v-col>
              </v-row>
              </div>
              </v-card>
              <v-card class="card-1 d-flex align-center mb-6">
                <label style="color: #4c4c4c; padding-left: 1em; font-weight: 700; font-size: 14px">
                    {{ $t('conditionScore0') }}
                    <br />
                    {{ $t('conditionScore1') }}
                    <br />
                    {{ $t('conditionScore2') }}
                </label>
               </v-card>

            </v-col>
          </v-row>
          <v-row style="margin: 1em 0">
            <v-col cols="12" sm="12" md="12">
              <v-data-table-server :items-per-page="options.itemsPerPage" :items-length="searchTotalTable" v-model:options="options"
                :items="dataTable" :headers="headers">
                <template v-slot:item="{ item }">
                  <tr>
                    <td style="text-align: left">{{ item.number }}</td>
                    <td style="text-align: left">{{ item.question }}</td>
                    <td style="text-align: left">{{ item.answer }}</td>
                    <td style="text-align: left">{{ item.humanAnswer }}</td>
                    <td style="text-align: left">{{ item.score ?? '-' }}</td>
                    <td style="text-align: left">{{ item.chatWorkFlow }}</td>
                  </tr>
                </template>
              </v-data-table-server>
            </v-col>
          </v-row>
        </v-flex>
      </v-card>
    </v-container>

    
    <v-dialog v-model="dialogReprocess" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t('_Reprocess') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-autocomplete 
                  label="Model Name" 
                  :items="DDGPTModel" 
                  item-title="name" 
                  item-value="modelDisplayID" 
                  clearable 
                  variant="outlined"
                  density="comfortable"
                  color="primary"
                  v-model="Reprocess.modelId" 
                  :rules="[rules.required]" 
                  required
                  class="modern-field"
                  hide-details="auto"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="primary" size="small">mdi-brain</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon
                          v-bind="props"
                          color="grey-darken-1"
                          size="small"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t('_InfoModelName') }}</span>
                    </v-tooltip> 
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-checkbox 
                  v-model="Reprocess.isScore" 
                  color="primary"
                  hide-details
                  class="modern-checkbox"
                >
                  <template v-slot:label>
                    <div class="checkbox-label-wrapper">
                      <v-icon size="small" color="primary" class="mr-2">mdi-calculator</v-icon>
                      <span>{{ $t('calculateScores') }}</span>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            v-bind="props"
                            color="grey-darken-1"
                            size="small"
                            class="ml-1"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>{{ $t('calculateScores') }}</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-checkbox>
              </v-col>
              <v-col cols="12" sm="12" md="12" v-show="Reprocess.isScore">
                <v-textarea 
                  label="Prompt" 
                  variant="outlined"
                  counter 
                  auto-grow 
                  rows="15" 
                  v-model="Reprocess.Prompt" 
                  required
                  color="primary"
                  class="modern-textarea"
                  hide-details="auto"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="primary" size="small">mdi-text-long</v-icon>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
          <!-- <small>*indicates required field</small> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="CloseDialogReprocess()"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="ReProcess()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay  :value="dialog">
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-overlay>
  </div>
</template>
<script>
import { Chart } from 'highcharts-vue';
import dateUtils from '../plugins/date-utils';
import moment from 'moment';
import Cookies from 'js-cookie';
export default {
  name: 'DashboardScore',
  inject:['FontColorTitle'],
  computed: {
    currentLanguage() {
      return this.$i18n.locale;
    },
    headers() {
      return [
          { title: this.$t('no'), align: 'left', sortable: false },
          { title: this.$t('question'), align: 'left', sortable: true ,value:'Question'},
          { title: this.$t('answer'), align: 'left', sortable: true,value:'Answer' },
          { title: this.$t('HumanAnswer'), align: 'left', sortable: true,value:'HumanAnswer' },
          { title: this.$t('score'), align: 'left', sortable: true ,value:'Score'},
          { title: this.$t('Chat work flow'), align: 'left', sortable: false ,value:'ChatWorkFlow'},
      ];
    },
  },

  watch: {
    currentLanguage(newLanguage) {
      // อัปเดตข้อความหรือสถานะ component เมื่อภาษาเปลี่ยน
      this.loadTranslations(newLanguage); // เรียกฟังก์ชันเพื่อโหลดข้อมูลหรือข้อความใหม่
    },
    options: {
      handler() {
        if (!this.isInitialized) return;
        this.GetTable();
      },
      deep: true,
    },
  },
  components: {
    highcharts: Chart,
  },
  data: () => ({
    props: ['id'],
    mask: '##########',
    isInitialized: false,
    show1: false,
    dialog: false,
    loading: false,
    loadingbtn: false,
    userList: [],
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTable: [],
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    isFirst: true,
    userId: Cookies.get('userId'),
    today: null,
    averageScore: 0,
    graphcategories: [],
    graphdata: [],
    language: 'th',
    DDValidationProcess: [],
    ProcessID: null,
    ModelID: null,
    ModelName: null,
    Version: null,
    processDate: null,

    rules: {
      required: (value) => !!value || 'Required',
    },
    isChartOptions: false,
    chartOptions: {
      chart: { type: 'column' },
      title: { text: '' },
      subtitle: { text: '' },
      credits: { enabled: false },
      xAxis: { categories: ['1x', '2x', '3x', '4x'], crosshair: true },
      yAxis: { min: 0, title: { text: 'จำนวนคน' } },
      tooltip: {
        enabled: false,
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b> {point.y:,.0f} คน</b></td></tr>',
        footerFormat: '</table>',
        shared: false,
        useHTML: false,
      },
      plotOptions: {
        column: {
          pointPadding: 0,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            formatter: function () {
              return parseFloat(this.y.toFixed(2)).toLocaleString() + ' คน';
            },
          },
        },
      },
      series: [
        {
          name: 'จำนวนคน',
          data: [1000000, 1, 1, 1],
          color: {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, '#9747FF'],
              [1, '#5179EF'],
            ],
          },
        },
      ],
      
    },
    sortBy: [],
    sortDesc :[],
    dialogReprocess: false,
    DDGPTModel: [],
    Prompt: null,
    IsScore: false,
    Reprocess:{
      modelId: null,
      isScore: false,
      Prompt: null,
    }
  }),
  methods: {
    loadTranslations(newLanguage) {
      this.language = newLanguage;
      let p = this.$t('setup_table_value');
      this.chartOptions.title = { text: this.$t('validationScore') };
      this.chartOptions.yAxis = {
        min: 0,
        title: { text: this.$t('NumberData') },
      };
      this.chartOptions.plotOptions = {
        column: {
          pointPadding: 0,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            formatter: function () {
              return parseFloat(this.y.toFixed(2)).toLocaleString() + ` ${p}`;
            },
          },
        },
      };
      this.chartOptions.series = [
        {
          name: this.$t('NumberData'),
          data: this.graphdata,
          color: {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, '#9747FF'],
              [1, '#5179EF'],
            ],
          },
        },
      ];
    },
    ConvertFormat(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    roundToTwoDecimalPlaces(number) {
      return Math.round((number + Number.EPSILON) * 100) / 100;
    },
    GetTable() {
      let self = this;
      self.dialog = true;
      self.loading = true;
      
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        page: page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        ProcessID: self.ProcessID,
        UserID: self.userId,
        sortDesc: sortOrder,
        sortBy: sortField
      };
      self.$call.GetTableValidationScore(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    SearchData(){
      let self = this;
      self.Get();
      self.GetTable();
    },
    Get() {
      let self = this;
      self.dialog = true;
      this.options.page = 1;
      let temp = {
        ProcessID: self.ProcessID,
        UserID: self.userId,
      };
      self.$call.GetDashboardValidationScore(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            const data = dataResponse.data;
            self.averageScore = self.roundToTwoDecimalPlaces(data.averageScore);
            self.graphcategories = data.categories;
            self.graphdata = data.data;
            self.ModelID = data.modelDisplayID;
            self.ModelName = data.modelName;
            self.Version = data.version;
            self.Prompt = data.prompt;
            self.IsScore = data.isScore;
            self.processDate = data.processDate;
            self.chartOptions.xAxis.categories = self.graphcategories;

            let p = self.$t('setup_table_value');
            self.chartOptions.title = { text: self.$t('validationScore') };
            self.chartOptions.yAxis = {
              min: 0,
              title: { text: self.$t('NumberData') },
            };
            self.chartOptions.plotOptions = {
              column: {
                pointPadding: 0,
                borderWidth: 0,
                dataLabels: {
                  enabled: true,
                  formatter: function () {
                    return parseFloat(this.y.toFixed(2)).toLocaleString() + ` ${p}`;
                  },
                },
              },
            };
            self.chartOptions.series = [
              {
                name: self.$t('NumberData'),
                data: self.graphdata,
                color: {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, '#9747FF'],
                    [1, '#5179EF'],
                  ],
                },
              },
            ];

            self.isChartOptions = true;
          }
          self.GetDDValidationProcess();
        },
        (errorResource) => {
          self.dialog = false;
          self.Adddialog = false;
          console.error(errorResource);
        }
      );
    },
    GetDDValidationProcess() {
      let self = this;
      self.dialog = true;
      self.$call.GetDDValidationProcess(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDValidationProcess = dataResponse.data;
          } else {
            self.DDValidationProcess = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    ProcessingScore() {
      let self = this;
      self.$swal.fire({
        title: this.$t('vectorReprocess'),
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('cancel'),

      }).then((result) => {
        if (result.isConfirmed) {
          self.dialog = true;
          self.loadingbtn = true;
          let temp = {
            ProcessID: self.ProcessID,
            UserID: self.userId,
          };
          self.$call.GenerateValidationScore(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.$router.push('/ValidationProcess');
              }
              self.dialog = false;
              self.loadingbtn = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.loadingbtn = false;
              console.error(errorResource);
            }
          );
        }
      })

    },
    convertDateToStringEn(date, seperator = '/') {
      return dateUtils.getStringWithMonthEnNameFromDate(moment(date).toDate(), seperator);
    },
    convertDateToStringTh(date, seperator = '/') {
      return dateUtils.getStringWithMonthNameFromDate(moment(date).toDate(), seperator);
    },
    OpenDialogReprocess() {
      let self = this;
      self.dialogReprocess = true;
      self.Reprocess.modelId = self.ModelID;
      self.Reprocess.isScore = self.IsScore;
      self.Reprocess.Prompt = self.Prompt;
    },
    CloseDialogReprocess() {
      let self = this;
      self.dialogReprocess = false;
      self.Reprocess.modelId = null;
      self.Reprocess.isScore = false;
      self.Reprocess.Prompt = null;
    },
    ReProcess(){
      let self = this;
        console.log(self.Reprocess);
        console.log(self.CheckNullInVariable(self.Reprocess.modelId));
      if(!self.CheckNullInVariable(self.Reprocess.modelId))
      {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: "Please select a model.",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      else if(self.Reprocess.isScore == true && !self.CheckNullInVariable(self.Reprocess.Prompt))
      {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: "Please enter the prompt.",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      self.dialog = true;
      self.loadingbtn = true;
      let temp = {
        ProcessID: self.ProcessID,
        ModelID: self.Reprocess.modelId,
        IsScore: self.Reprocess.isScore,
        Prompt: self.Reprocess.Prompt,
      };
      self.$call.SetReprocessValidationProcess(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: 'success',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
            self.$router.push('/ValidationProcess');
          }
          self.dialog = false;
          self.loadingbtn = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.loadingbtn = false;
          console.error(errorResource);
        }
      );
    },
    GetDDGPTModel() {
      let self = this;
      self.dialog = true;
      self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGPTModel = dataResponse.data;
          } else {
            self.DDGPTModel = [];
          }
          // self.GetValidationGenerateDD();
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    CheckNullInVariable(variable) {
      if(variable == null || variable == undefined || variable == "")
      {
        return false;
      }
      else
      {
        return true;
      }
    },
  },
  mounted() {
    let self = this;
    self.language = self.$i18n.locale;
    self.GetDDGPTModel();
    if (self.$route.query.id) {
      if (self.$route.query.id != null) {
        self.ProcessID = self.$route.query.id;
        self.Get();
      }
    }
    self.GetTable();
    self.isInitialized = true;
  },
};
</script>
<style scoped>
.card-1 {
  border-radius: 13px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 125px;
  flex-shrink: 0;
}

.card-2 {
  border-radius: 13px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 400px;
  flex-shrink: 0;
}

.card-3 {
  border-radius: 13px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 160px;
  flex-shrink: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.circular--portrait {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
  border-radius: 50%;
}

.circular--portrait img {
  width: 100%;
  height: auto;
}

.gradient-red {
  background: -webkit-linear-gradient(red, yellow);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gradient-purple {
  background: -webkit-linear-gradient(#9747ff, #5179ef);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.modern-field {
  margin-top: 8px;
}

.modern-field :deep(.v-field) {
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
}

.modern-field :deep(.v-field__outline) {
  border-width: 2px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  transition: all 0.3s ease !important;
}

.modern-field :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-field:hover :deep(.v-field__outline) {
  border-color: rgba(25, 118, 210, 0.6) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.modern-field :deep(.v-label) {
  font-weight: 600 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.25px !important;
}

.modern-field :deep(.v-field--focused .v-label) {
  color: #1976d2 !important;
}

.modern-field :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 500 !important;
  color: #333 !important;
  padding: 16px 12px !important;
}

.modern-field :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
  font-style: italic;
}

.modern-field :deep(.v-field__prepend-inner) {
  padding-right: 8px !important;
}

.modern-field :deep(.v-field__append-inner) {
  padding-left: 8px !important;
}
.modern-textarea {
  margin-top: 8px;
}

.modern-textarea :deep(.v-field) {
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
}

.modern-textarea :deep(.v-field__outline) {
  border-width: 2px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  transition: all 0.3s ease !important;
}

.modern-textarea :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-textarea:hover :deep(.v-field__outline) {
  border-color: rgba(25, 118, 210, 0.6) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.modern-textarea :deep(.v-label) {
  font-weight: 600 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.25px !important;
}

.modern-textarea :deep(.v-field--focused .v-label) {
  color: #1976d2 !important;
}

.modern-textarea :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 500 !important;
  color: #333 !important;
  padding: 16px 12px !important;
}

.modern-textarea :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
  font-style: italic;
}

.modern-textarea :deep(.v-field__prepend-inner) {
  padding-right: 8px !important;
}

/* =============================================================================
   MODERN CHECKBOX STYLES
   ============================================================================= */
.modern-checkbox :deep(.v-selection-control) {
  background: rgba(248, 249, 250, 0.8);
  border-radius: 12px;
  padding: 12px 16px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.modern-checkbox :deep(.v-selection-control:hover) {
  background: rgba(248, 249, 250, 1);
  border-color: rgba(25, 118, 210, 0.2);
}

.modern-checkbox :deep(.v-selection-control--dirty) {
  border-color: rgba(25, 118, 210, 0.3);
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.checkbox-label-wrapper {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #495057;
}
.search-btn {
  border-radius: 50% !important;
  width: 56px !important;
  height: 56px !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%) !important;
}

.search-btn:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.05) !important;
  box-shadow: 0 8px 20px rgba(25, 118, 210, 0.4) !important;
}

.search-btn:active:not(:disabled) {
  transform: translateY(0) scale(1) !important;
}

.search-btn:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.search-btn .v-icon {
  color: white !important;
  transition: transform 0.2s ease !important;
}

.search-btn:hover:not(:disabled) .v-icon {
  transform: scale(1.1) !important;
}

/* Pulse animation when loading */
.search-btn.loading {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
  }
  50% {
    box-shadow: 0 4px 20px rgba(25, 118, 210, 0.6);
  }
  100% {
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
  }
}

/* =============================================================================
   REPROCESS BUTTON ENHANCEMENT
   ============================================================================= */
.reprocess-btn {
  border-radius: 25px !important;
  background: linear-gradient(135deg, #9747ff 0%, #7c3aed 100%) !important;
  box-shadow: 0 4px 15px rgba(151, 71, 255, 0.3) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

.reprocess-btn:hover:not(:disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(151, 71, 255, 0.4) !important;
}

.reprocess-btn:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

/* =============================================================================
   RESPONSIVE DESIGN
   ============================================================================= */
@media (max-width: 768px) {
  .search-btn {
    width: 48px !important;
    height: 48px !important;
  }
  
  .search-btn .v-icon {
    font-size: 20px !important;
  }
}
</style>
